import React, { useState } from "react";
import OtpInputContainer from "../OtpInputContainer/OtpInputContainer";
import styles from "./LoginOtpVerify.module.css";
import ButtonComponent from "../../CssComponents/ButtonComponent/ButtonComponent";
import { db } from "../../../firebase-config";
import { doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../../provider/Auth.provider";

// signin components - after receiving otp
const LoginOtpVerify = ({ onOtpVerify, onResendOtp }) => {
  const [otp, setOtp] = useState("");
  const { user } = useAuth();
  const handleOtpChange = (otpComing) => {
    setOtp(otpComing);
  };

  //   const updateLastActive = async (userId) => {
  //     try {
  //       const userRef = doc(db, "users", userId); // reference to the specific document

  //       await updateDoc(userRef, {
  //         lastActive: new Date(), // you can set any value here
  //       });

  //       console.log("User lastActive updated successfully!");
  //     } catch (error) {
  //       console.error("Error updating lastActive:", error);
  //     }
  //   };
  // onClick of button

  const handleSignIn = (e) => {
    e.preventDefault();
    onOtpVerify(otp);
  };

  return (
    <div className={styles.verifyContainer}>
      <div>Enter OTP</div>
      <OtpInputContainer onOtpChange={handleOtpChange} />
      <div className={styles.info}>
        <div className={styles.rememberme}>
          <input className={styles.checkbox} type="checkbox" />
          <p> Keep me logged in</p>
        </div>
        <button
          onClick={onResendOtp ? () => onResendOtp() : () => {}}
          className={styles.resendButton}
        >
          Resend OTP
        </button>
      </div>
      <ButtonComponent
        onClick={handleSignIn}
        className={styles.verifyButton}
        buttonText={"Sign In - Verify OTP"}
      />
    </div>
  );
};

export default LoginOtpVerify;
